import * as api from '../api';
import { BASE_ASSET_URL_PROD } from 'common/dist/utils/url';

///////////////////////////////////////////////////
//////TYPES

interface Customer {
  name: string;
  subdomain: string;
  logoUrl: string;
  domain?: string;
  primaryHexColor?: string;
  secondaryHexColor?: string;
}

///////////////////////////////////////////////////
//////PRIVATE

export const customers: Customer[] = [
  {
    name: 'austinregionalclinic',
    domain: 'austinregionalclinic',
    subdomain: 'arc',
    logoUrl: `${BASE_ASSET_URL_PROD}/arc-logo.png`,
    primaryHexColor: '#8334ad',
    secondaryHexColor: '#58287a',
  },
  {
    name: 'banner',
    subdomain: 'banner',
    logoUrl: `${BASE_ASSET_URL_PROD}/banner-logo.png`,
  },
  {
    name: 'bswhealth',
    subdomain: 'bswhealth',
    logoUrl: `${BASE_ASSET_URL_PROD}/bswhealth-logo.png`,
    primaryHexColor: '#01559e',
    secondaryHexColor: '#018fbd',
  },
  {
    name: 'chistlukeshealth',
    domain: 'chisaintjosephhealth',
    subdomain: 'chisaintjosephhealth',
    logoUrl: `${BASE_ASSET_URL_PROD}/chistlukes-logo.png`,
    primaryHexColor: '#012598',
    secondaryHexColor: '#012598',
  },
  {
    name: 'chistlukeshealth',
    domain: 'chistlukeshealth',
    subdomain: 'chistlukeshealth',
    logoUrl: `${BASE_ASSET_URL_PROD}/chistlukes-logo.png`,
    primaryHexColor: '#012598',
    secondaryHexColor: '#012598',
  },
  {
    name: 'dignity',
    domain: 'dignityhealth',
    subdomain: 'dignity',
    logoUrl: `${BASE_ASSET_URL_PROD}/dignity-logo.png`,
    primaryHexColor: '#007ee5',
    secondaryHexColor: '#e8691a',
  },
  {
    name: 'familymd',
    subdomain: 'familymd',
    logoUrl: `${BASE_ASSET_URL_PROD}/familymd-logo.png`,
    primaryHexColor: '#005fb3',
    secondaryHexColor: '#005fb3',
  },
  {
    name: 'gbo',
    subdomain: 'gbo',
    logoUrl: `${BASE_ASSET_URL_PROD}/gbo-logo.png`,
    primaryHexColor: '#0058a6',
    secondaryHexColor: '#0058a6',
  },
  {
    name: 'houstonmethodist',
    subdomain: 'houstonmethodist',
    logoUrl: `${BASE_ASSET_URL_PROD}/houston-methodist-logo.png`,
    primaryHexColor: '#005099',
    secondaryHexColor: '#005099',
  },
  {
    name: 'intermountain',
    domain: 'intermountainhealthcare',
    subdomain: 'intermountain',
    logoUrl: `${BASE_ASSET_URL_PROD}/intermountain-logo.png`,
    primaryHexColor: '#005099',
    secondaryHexColor: '#00439f',
  },
  {
    name: 'lux',
    subdomain: 'lux',
    logoUrl: `${BASE_ASSET_URL_PROD}/lux-logo.png`,
    primaryHexColor: '#373535',
    secondaryHexColor: '#96989B',
  },
  {
    name: 'nahealth',
    subdomain: 'nahealth',
    logoUrl: `${BASE_ASSET_URL_PROD}/nahealth-logo.png`,
    primaryHexColor: '#3f5d88',
    secondaryHexColor: '#3d5c4a',
  },
  {
    name: 'nkch',
    subdomain: 'nkch',
    logoUrl: `${BASE_ASSET_URL_PROD}/nkch-logo.png`,
    primaryHexColor: '#00597C',
    secondaryHexColor: '#00597C',
  },
  {
    name: 'northwellhealth',
    subdomain: 'northwellhealth',
    logoUrl: `${BASE_ASSET_URL_PROD}/northwellhealth-logo.png`,
    primaryHexColor: '#2430A0',
    secondaryHexColor: '#AE12D7',
  },
  {
    name: 'otter',
    subdomain: 'otter',
    logoUrl: `${BASE_ASSET_URL_PROD}/otter-logo.png`,
    primaryHexColor: '#3872D4',
    secondaryHexColor: '#1A74DB',
  },
  {
    name: 'pcma',
    subdomain: 'pcma',
    logoUrl: `${BASE_ASSET_URL_PROD}/demo-logo.png`,
    primaryHexColor: '#1a74db',
    secondaryHexColor: '#1a74db',
  },
  {
    name: 'pmg',
    subdomain: 'pmg',
    logoUrl: `${BASE_ASSET_URL_PROD}/pmg-logo.png`,
    primaryHexColor: '#005099',
    secondaryHexColor: '#005099',
  },
  {
    name: 'providence',
    subdomain: 'providence',
    logoUrl: `${BASE_ASSET_URL_PROD}/providence-logo.png`,
    primaryHexColor: '#0c3c94',
    secondaryHexColor: '#0c3c94',
  },
  {
    name: 'resurgens',
    subdomain: 'resurgens',
    logoUrl: `${BASE_ASSET_URL_PROD}/resurgens-logo.png`,
    primaryHexColor: '#023e83',
    secondaryHexColor: '#0c3b71',
  },
  {
    name: 'sacredheart',
    subdomain: 'sacredheart',
    logoUrl: `${BASE_ASSET_URL_PROD}/sacredheart-logo.png`,
    primaryHexColor: '#db2b39',
    secondaryHexColor: '#2274a5',
  },
  {
    name: 'shivaniberi',
    domain: 'drshivaniberi',
    subdomain: 'shivaniberi',
    logoUrl: `${BASE_ASSET_URL_PROD}/shivaniberi-logo.png`,
    primaryHexColor: '#253551',
    secondaryHexColor: '#253551',
  },
  {
    name: 'sutter',
    subdomain: 'sutter',
    logoUrl: `${BASE_ASSET_URL_PROD}/pamf-logo.png`,
    primaryHexColor: '#35a6b0',
    secondaryHexColor: '#35a6b0',
  },
  {
    name: 'unitedallergy',
    subdomain: 'unitedallergy',
    logoUrl: `${BASE_ASSET_URL_PROD}/unitedallergy-logo.png`,
    primaryHexColor: '#005fb3',
    secondaryHexColor: '#005fb3',
  },
  {
    name: 'villagemd',
    subdomain: 'villagemd',
    logoUrl: `${BASE_ASSET_URL_PROD}/villagemd-logo.png`,
    primaryHexColor: '#17335b',
    secondaryHexColor: '#17335b',
  },
];

const unknownCustomer: Customer = {
  name: '',
  subdomain: '',
  logoUrl: `${BASE_ASSET_URL_PROD}/demo-logo.png`,
};

///////////////////////////////////////////////////
//////PUBLIC

export function getCustomer(customerName?: string | null): Customer {
  if (customerName) {
    return (
      customers.find((customer) => customer.name === customerName) ||
      unknownCustomer
    );
  }
  const { hostname } = window.location;
  const fqdnComponents = hostname.split('.');
  const domain = fqdnComponents[1];
  const subdomain = fqdnComponents[0];
  for (const customer of customers) {
    if (
      (domain && customer.domain === domain) ||
      (subdomain && customer.subdomain === subdomain)
    ) {
      return customer;
    }
  }

  return unknownCustomer;
}

export function constructAddress(
  practice: Pick<Partial<api.Address.Address>, 'address' | 'city' | 'zip'> & {
    state?: string | null;
  },
): string {
  let result = '';
  const { address, city, state, zip } = practice;
  if (address) result += address;
  if (city) result += result.length ? ', ' + city : city;
  if (state) result += result.length ? ', ' + state : state;
  if (zip) result += result.length ? ' ' + zip : zip;
  return result.trim();
}

/**
 * @Deprecated migrate to {@link constructAddress}
 */
export function constructAddressSchedulingConfirmation({
  address,
  city,
  state,
  zip,
}: {
  address: string;
  city: string;
  state: string;
  zip: string;
}): string {
  return `${address} ${city}, ${state} ${zip}`;
}
